module.exports = __webpack_public_path__ + "static/media/01.eb915940.jpg";